module.exports = __webpack_public_path__ + "img/auth-back.44f2cb13.png";